import { FullRegistration, Program } from 'app/entities/registration/registration.types';

export function missingMusicTrackCount(registration: FullRegistration): number {
  if (registration.status === 'CANCELLED') {
    return 0;
  }
  const sportType = registration.sportType !== 'STARA' ? registration.sportType : registration.categoryCode;
  if (sportType === 'MAG' || sportType === 'TUM') {
    return 0;
  }
  let programsWithRequiredMusic: Program[] = registration.programs;
  if (sportType === 'WAG') {
    programsWithRequiredMusic = [registration.programs.find((program) => program.apparatus === 'FLOOR')];
  } else if (sportType === 'TG') {
    programsWithRequiredMusic = [registration.programs.find((program) => program.type === 'FREE')];
  }
  return programsWithRequiredMusic.reduce((count, program) => {
    if (program && program.orderNumber > 0) {
      return count + (program.musicTrack ? 0 : 1);
    }
    return count;
  }, 0);
}
